/* Progressive enhancement: keep the complete Liquid content readable without JS. */
(() => {
  'use strict';
  document.addEventListener('click', event => {
      const button = event.target.closest('[data-pdp-play]');
      if (!button) return;
        const container = button.closest('[data-pdp-video]');
        const template = container.querySelector('template');
        if (!template) return;
        button.replaceWith(template.content.cloneNode(true));
        const video = container.querySelector('video');
        video?.focus();
        video?.play()?.catch(() => {});
  });
  document.addEventListener('play', event => {
    if (event.target.closest?.('[data-product-explorer]')) document.querySelector('[data-mobile-buy]')?.setAttribute('hidden', '');
  }, true);
  const restoreBuy = event => {
    if (event.target.closest?.('[data-product-explorer]')) document.querySelector('[data-mobile-buy]')?.removeAttribute('hidden');
  };
  document.addEventListener('pause', restoreBuy, true);
  document.addEventListener('ended', restoreBuy, true);
})();
